import React, { useEffect, useState } from "react";
import { Menu, Layout } from "antd";
import { useLocation, useHistory } from "react-router-dom";
import logo from "assets/images/eied-logo.svg";
import Menus from "./Links";
// API
import { authenticationServices } from "services/authenticationServices";

const { Item, SubMenu } = Menu;
const { Sider } = Layout;

const Sidebar = ({ collapsed }) => {
  const history = useHistory();
  const [userInfo, setUserInfo] = useState();

  const getUserInfo = async () => {
    let user = await authenticationServices.userInfo();
    setUserInfo(user);
    // let profile=JSON.parse(localStorage.getItem("user-profile"));
    // debugger
    // if(profile){
    //   let userinfo={};
    //   userinfo.firstName=profile.firstName;
    //   userinfo.lastName=profile.lastName;
    //   userinfo.userName=profile.userName;
    //   userinfo.fullName=profile.firstName + '-' + profile.lastName;

    //   setUserInfo(userinfo);
    // }
    // else{
      
    //   setUserInfo(user);

    // }
  };

  const onMenuClick = (menuItem) => {
    const { path } = menuItem;
    history.push(path);
  };

  const renderItemMenu = (item) => {
    return (
      <Item key={item.id} onClick={() => onMenuClick(item)}>
        <span>
          {" "}
          {item.icon}
          {item.name}
        </span>
      </Item>
    );
  };

  useEffect(() => {
    getUserInfo();
    
  }, [userInfo]);
  return (
    <div className="sideBar">
      <Sider
        width={260}
        collapsedWidth={0}
        breakpoint="lg"
        trigger={null}
        mode="inline"
        collapsible
        collapsed={collapsed}
      >
        <div className="logo">
          <img src={logo} alt="" />

          {!collapsed && <b>{"پنل مدیریت فروشگاه "}</b>}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["1"]}
          defaultOpenKeys={["sub1"]}
        >
          {Menus?.map((m) => {
            if (m.path) {
              return renderItemMenu(m);
            } else {
              return (
                <SubMenu
                  key={m.id}
                  title={
                    <span>
                      {m.icon}
                      <span>{m.name}</span>
                    </span>
                  }
                >
                  {m?.children?.map((item) => renderItemMenu(item))}
                </SubMenu>
              );
            }
          })}
        </Menu>
      </Sider>
    </div>
  );
};

export default Sidebar;
